import { GetPublicDocumentsByAssociation } from './GetPublicDocumentsByAssociation';
import { QueryHandler } from '../../_base/actionBus/QueryHandler';
import { DocumentService } from '../../models/documents/DocumentService';
import { Document } from '../../models/documents/Document';

export class GetPublicDocumentsByAssociationHandler implements QueryHandler<GetPublicDocumentsByAssociation, Document[]> {
    constructor(private readonly documentService: DocumentService) {}

    async handle(query: GetPublicDocumentsByAssociation): Promise<Document[]> {
        return await this.documentService.getPublicDocumentsByAssociation(query.associationId, query.parentId);
    }
}
